import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=fcb4157e&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=fcb4157e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb4157e",
  null
  
)

export default component.exports